module.exports = "/_next/static/images/Mohammed_Sadiq_Mabeko-5bf0665d73145c272122c0b7419a9851.webp";